import { Helmet } from 'react-helmet-async';
import { PageLayout } from '@/components/layout/PageLayout';

export default function NotFoundPage() {
  return (
    <PageLayout>
      <Helmet>
        <title>Page Not Found | Stakeholder Takeover</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="container-md">
        <div className="row">
          <div className="col-lg-12">
            <div id="message">
              <h1>404</h1>
              <h2>Page Not Found</h2>
              <p>The specified page was not found on this website. Please check the URL for mistakes and try again, or select the page you would like to go to from the menu above.</p>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
